var _ellipse, _rect, _rect2, _path, _path2, _rect3, _rect4, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 238,
    viewBox: "0 0 342 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 163.816,
    cy: 104.381,
    rx: 163.816,
    ry: 104.381,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 363.023 90.611)",
    fill: "#72A4FC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.3051,
    y: 63.6884,
    width: 100.035,
    height: 155.091,
    rx: 3.75,
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.4173,
    y: 77.8005,
    width: 71.811,
    height: 71.811,
    rx: 2,
    fill: "#C4D9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160.228 160.186C160.228 159.634 159.781 159.186 159.228 159.186H89.4173C88.865 159.186 88.4173 159.634 88.4173 160.186V170.155C88.4173 170.707 88.865 171.155 89.4173 171.155H159.228C159.781 171.155 160.228 170.707 160.228 170.155V160.186Z",
    fill: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M160.228 181.73C160.228 181.177 159.781 180.73 159.228 180.73H89.4173C88.865 180.73 88.4173 181.177 88.4173 181.73V203.667C88.4173 204.219 88.865 204.667 89.4173 204.667H159.228C159.781 204.667 160.228 204.219 160.228 203.667V181.73Z",
    fill: "#72A4FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 134.147,
    y: 18.2079,
    width: 133.547,
    height: 176.634,
    rx: 3.75,
    fill: "white",
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 148.26,
    y: 32.3201,
    width: 105.323,
    height: 71.811,
    rx: 2,
    fill: "#C4D9FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M246.401 114.706C246.401 114.154 245.954 113.706 245.401 113.706H149.26C148.707 113.706 148.26 114.154 148.26 114.706V124.674C148.26 125.227 148.707 125.674 149.26 125.674H245.401C245.954 125.674 246.401 125.227 246.401 124.674V114.706Z",
    fill: "#E7E7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.827 136.249C236.827 135.697 236.379 135.249 235.827 135.249H149.26C148.707 135.249 148.26 135.697 148.26 136.249V146.218C148.26 146.77 148.707 147.218 149.26 147.218H235.827C236.379 147.218 236.827 146.77 236.827 146.218V136.249Z",
    fill: "#E7E7E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M253.582 157.792C253.582 157.24 253.135 156.792 252.582 156.792H149.26C148.707 156.792 148.26 157.24 148.26 157.792V179.729C148.26 180.282 148.707 180.729 149.26 180.729H252.582C253.135 180.729 253.582 180.282 253.582 179.729V157.792Z",
    fill: "#72A4FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailable);
export default __webpack_public_path__ + "static/media/unavailable.96f89acd.svg";
export { ForwardRef as ReactComponent };